(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bada-load-more"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('bada-load-more')) return;

    const ITEM_SELECTOR = ':scope > [ref="cards[]"]';

    /**
     * Load more button for results-list. A plain element (not a Component), so the viewMoreNext ref inside it still
     * belongs to results-list, which owns fetching, appending and the URL.
     */
    class BadaLoadMore extends HTMLElement {
      /** @type {AbortController | undefined} */
      #controller;
      /** @type {MutationObserver | undefined} */
      #observer;
      /** @type {number | undefined} */
      #timer;

      connectedCallback() {
        this.#controller = new AbortController();
        const link = this.querySelector('[data-load-more-link]');
        const button = this.querySelector('[data-load-more-button]');
        if (!(button instanceof HTMLButtonElement)) return;

        if (link instanceof HTMLElement) link.hidden = true;
        button.hidden = false;
        button.addEventListener('click', this.#load, { signal: this.#controller.signal });
        this.#sync(false);
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#observer?.disconnect();
        if (this.#timer) window.clearTimeout(this.#timer);
      }

      get #grid() {
        return this.closest('results-list')?.querySelector('[ref="grid"]') ?? null;
      }

      /** @param {string | undefined} template @param {Record<string, string | number>} values */
      #fill(template, values) {
        let text = template ?? '';
        for (const [key, value] of Object.entries(values)) text = text.replaceAll(`[${key}]`, String(value));
        return text;
      }

      /** @returns {object} items (HTMLElement[]), lastPage and loadedPage (numbers) */
      #state() {
        const grid = this.#grid;
        const items = grid ? /** @type {HTMLElement[]} */ ([...grid.querySelectorAll(ITEM_SELECTOR)]) : [];
        const lastPage = Number(grid?.getAttribute('data-last-page') || 1);
        const loadedPage = Number(items.at(-1)?.dataset.page || 1);
        return { items, lastPage, loadedPage };
      }

      /** @param {boolean} announce @param {number} [added] */
      #sync(announce, added = 0) {
        const total = Number(this.dataset.total || 0);
        const size = Number(this.dataset.pageSize || 24);
        const { items, lastPage, loadedPage } = this.#state();
        // Cards actually listed (sold-out products never are), plus the pages before the first loaded one
        const firstPage = Number(items[0]?.dataset.page || 1);
        const listed = items.filter((item) => !item.hidden).length;
        const shown = Math.min(total, (firstPage - 1) * size + listed);
        const remaining = Math.max(0, total - shown);

        const text = this.querySelector('[data-load-more-text]');
        if (text) text.textContent = this.#fill(this.dataset.showingTemplate, { shown, total });

        const line = /** @type {HTMLElement | null} */ (this.querySelector('.bada-load-more__line span'));
        line?.style.setProperty('--bada-progress', String(total ? shown / total : 0));

        const button = this.querySelector('[data-load-more-button]');
        if (button instanceof HTMLButtonElement) {
          button.hidden = loadedPage >= lastPage || remaining === 0;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = this.#fill(this.dataset.buttonTemplate, { count: Math.min(size, remaining) });
        }

        if (announce) {
          const status = this.querySelector('[data-load-more-status]');
          if (status) {
            status.textContent = '';
            window.setTimeout(() => {
              status.textContent =
                added === 1 ? this.dataset.loadedOne || '' : this.#fill(this.dataset.loadedOther, { count: added });
            }, 40);
          }
        }
      }

      #load = () => {
        const grid = this.#grid;
        const sentinel = this.querySelector('.bada-load-more__sentinel');
        const button = this.querySelector('[data-load-more-button]');
        if (!grid || !(sentinel instanceof HTMLElement) || !(button instanceof HTMLButtonElement)) return;

        const before = this.#state().items.length;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const done = () => {
          this.#observer?.disconnect();
          if (this.#timer) window.clearTimeout(this.#timer);
          sentinel.hidden = true;
        };

        this.#observer?.disconnect();
        this.#observer = new MutationObserver(() => {
          const { items } = this.#state();
          if (items.length <= before) return;
          done();
          const added = items.slice(before).filter((item) => !item.hidden);
          // A page of sold-out products adds only its hidden marker: fetch the next page instead of announcing nothing
          if (added.length === 0) {
            this.#sync(false);
            if (!button.hidden) {
              // Let the sentinel's hidden state reach layout so results-list sees it intersect again
              requestAnimationFrame(() => requestAnimationFrame(() => this.#load()));
            }
            return;
          }
          this.#sync(true, added.length);
          const focusTarget = added[0]?.querySelector('a[href]');
          if (focusTarget instanceof HTMLElement) focusTarget.focus({ preventScroll: false });
        });
        this.#observer.observe(grid, { childList: true });

        // Nothing arrived (network error, no next page): give the button back
        this.#timer = window.setTimeout(() => {
          done();
          this.#sync(false);
        }, 10000);

        // results-list observes the sentinel; showing it inside the viewport triggers the next page
        sentinel.hidden = false;
      };
    }

    customElements.define('bada-load-more', BadaLoadMore);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bada-media-fit"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('bada-media-fit')) return;

    const CACHE_KEY = 'bada-fit-2';
    const POINTS = [
      [1, 1],
      [22, 1],
      [1, 22],
      [22, 22],
      [12, 1],
      [1, 12],
    ];
    /** @type {Record<string, boolean>} */
    let cache = {};
    try {
      cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}') || {};
    } catch {
      cache = {};
    }

    const save = () => {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      } catch {
        /* storage full or blocked: the probe simply runs again next time */
      }
    };

    /** @param {Uint8ClampedArray} data */
    const isWhite = (data) => {
      const min = Math.min(data[0], data[1], data[2]);
      const max = Math.max(data[0], data[1], data[2]);
      return min >= 250 && max - min < 6;
    };

    class BadaMediaFit extends HTMLElement {
      connectedCallback() {
        const host = this.closest(this.dataset.scope || '.card-gallery');
        if (!(host instanceof HTMLElement) || host.dataset.badaFit !== 'auto') return;

        const image = host.querySelector('img');
        if (!(image instanceof HTMLImageElement)) return;

        const source = image.currentSrc || image.src;
        if (!source) {
          image.addEventListener('load', () => this.connectedCallback(), { once: true });
          return;
        }

        /** @type {URL} */
        let url;
        try {
          url = new URL(source, window.location.href);
        } catch {
          return;
        }

        const key = url.pathname;
        if (key in cache) {
          host.dataset.badaFit = cache[key] ? 'photo' : 'pack';
          return;
        }

        url.searchParams.set('width', '40');
        url.searchParams.delete('height');
        url.searchParams.delete('crop');

        const probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.decoding = 'async';
        probe.addEventListener(
          'load',
          () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = 24;
              canvas.height = 24;
              const context = canvas.getContext('2d', { willReadFrequently: true });
              if (!context) return;
              context.drawImage(probe, 0, 0, 24, 24);
              let white = 0;
              for (const [x, y] of POINTS) {
                if (isWhite(context.getImageData(x, y, 1, 1).data)) white += 1;
              }
              const photo = white < 4;
              cache[key] = photo;
              save();
              host.dataset.badaFit = photo ? 'photo' : 'pack';
            } catch {
              /* tainted canvas: keep the packshot default */
            }
          },
          { once: true }
        );
        probe.src = url.href;
      }
    }

    customElements.define('bada-media-fit', BadaMediaFit);
  })();
  } catch(e) { console.error(e); }
})();

})();
